window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

try {
    window.$ = window.jQuery = require('jquery');
    window.Money = require('js-money');

    require('bootstrap-sass');
    window._ = require('underscore');

    window.moment = require('moment-timezone');
    window.moment.locale('en-gb');
    moment.tz.setDefault('Europe/London');

    require('bootstrap-select');
    require('eonasdan-bootstrap-datetimepicker');

    $(function () {
        $('.selectpicker').selectpicker({
            size: 4
        });
    });

    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    })

    //Date time pickers
    $(function () {
        $('.datetimepicker').datetimepicker({
            format: 'DD/MM/YYYY H:mm',
            sideBySide: true
        });

        $('.datepicker').datetimepicker({
            format: 'DD/MM/YYYY',
            sideBySide: true
        });

        $('.timepicker').datetimepicker({
            format: 'DD/MM/YYYY',
            sideBySide: true
        });
    });

} catch (e) {
    alert(e);
}



// WEBPACK FOOTER //
// ./src/Assets/bootstrap.js